module.exports = __webpack_public_path__ + "static/img/1.04cde8ad.png";